import { isEmpty } from 'lodash';
import React from 'react';

export const GenerateMessageOnLeave = ({
  listOfSteps,
  resource,
  resourceName
}) => {
  const stepsForgotten = listOfSteps.filter(step => !step.completed);
  const isResourceCreated = listOfSteps[0].completed;

  function templateMessage(stepForgotten) {
    let lastElement = '';
    if (stepForgotten.length > 1) {
      lastElement = 'and ' + stepForgotten.pop();
    }

    return (
      <>
        <p style={{ margin: 0 }}>
          You are about to quit the creation process and return to
          {isResourceCreated ? ` ${resource} details ` : ` ${resource} list `}
          screen.
          <br />
          Your progress on this step will not be saved.
        </p>
        {!isEmpty(stepForgotten) && isResourceCreated && (
          <p>
            <span style={{ fontWeight: 'bold' }}>{resourceName} </span>
            has been created without {stepForgotten.join(', ')}
            {lastElement ? ` ${lastElement}` : ''}.
          </p>
        )}
      </>
    );
  }

  const stepsName = stepsForgotten.map(item => item.leavingPromptLabel);
  return templateMessage(stepsName);
};
